import { render, staticRenderFns } from "./SharingIndicators.vue?vue&type=template&id=6e2c3bc9"
import script from "./SharingIndicators.vue?vue&type=script&setup=true&lang=ts"
export * from "./SharingIndicators.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports